export const FileTypeEnum ={
  IMAGE : 'image',
  AUDIO : 'audio',
  VIDEO : 'video',
  OTHERS : 'others',
  /** 文稿, 包含doc */
  WORD : 'word',
  /** 电子表格 */
  EXCEL : 'excel',
  /** 演示文稿 */
  PPT : 'ppt',
  /** 压缩文件 */
  ZIP : 'zip',
  /** 可执行文件 */
  EXE : 'exe',
  PDF:'pdf',
  TXT:'txt'
}

export const IMAGE_MIMETYPE_ARRAY = [
  'image/webp', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'
]